<template>
	<div>
		<PageHeader
			:data="{
				name: county.name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Counties', to: '/counties' },
				],
			}"
		/>

		<div v-if="!loading" class="row">
			<div class="col-4">
				<div class="card mb-2">
					<div class="card-body">
						<div class="row border-bottom mb-2 pb-1">
							<div class="col-2">
								<h1>💼</h1>
							</div>
							<div class="col-10">
								<h4 class="mb-0">
									{{ county.name }}
								</h4>
								<span> {{ county.state }} </span>
							</div>
						</div>

						<p class="m-0 p-0" v-if="county.website">
							<b>Website</b>:
							<a v-if="county.website.includes('http')" :href="county.website" target="_blank"
								>{{ county.website }} 🔗</a
							>
							<a v-else :href="'http://' + county.website" target="_blank"
								>{{ 'http://' + county.website }} 🔗</a
							>
						</p>

						<p class="m-0 p-0" v-if="county.activities">
							<b>Activities</b>:
							{{ county.activities }}
						</p>

						<button
							v-if="authUser.email == 'srdjank90@gmail.com'"
							@click="deleteCounty()"
							class="btn btn-danger w-100 mt-3"
						>
							<font-awesome-icon :icon="['fas', 'trash']" class="me-2" /> Delete
						</button>
					</div>
				</div>

				<button
					v-if="authUser.permissions.includes('ACTIVITY_ACCESS') || authUser.email.includes('srdjan')"
					data-bs-toggle="offcanvas"
					data-bs-target="#offcanvasActivities"
					aria-controls="offcanvasActivities"
					class="btn btn-outline-secondary float-end"
					title="Contact history of changes"
					type="button"
				>
					<font-awesome-icon :icon="['fas', 'history']" /> History of changes
				</button>
			</div>
			<div class="col-8">
				<div class="card mb-2">
					<div class="card-body">
						<div class="row mb-3">
							<h5>💼 Main info</h5>
							<!-- Name -->
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">Name</label>
									<input class="form-control" type="text" v-model="county.name" />
								</div>
							</div>

							<!-- FISP -->
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">FIPS</label>
									<input class="form-control" type="text" v-model="county.fips" />
								</div>
							</div>

							<!-- FISP full -->
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">FIPS Full</label>
									<input class="form-control" type="text" v-model="county.fips_full" />
								</div>
							</div>
						</div>

						<!-- Location info -->
						<div class="row mb-3">
							<h5>📍Location info</h5>

							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">State</label>
									<input
										class="form-control"
										:class="county.state ? '' : 'border-danger'"
										type="text"
										v-model="county.state"
									/>
								</div>
							</div>
							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">County Seat</label>
									<input
										class="form-control"
										:class="county.county_seat ? '' : 'border-danger'"
										type="text"
										v-model="county.county_seat"
									/>
								</div>
							</div>

							<div class="col-4 mb-2">
								<div class="form-group">
									<label for="">Zip</label>
									<input class="form-control" type="text" v-model="county.zip" />
								</div>
							</div>

							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Mailing address</label>
									<input class="form-control" type="text" v-model="county.mailing_address" />
								</div>
							</div>

							<div class="col-12 mb-2">
								<div class="form-group">
									<label for="">Physical address </label>
									<input class="form-control" type="text" v-model="county.physical_address" />
								</div>
							</div>
						</div>

						<!-- Contact info -->
						<div class="row mb-3">
							<h5>📇 Contact info</h5>
							<small class="mb-2">
								ℹ️ County contact information
							</small>
							<div class="col-6">
								<div class="form-group">
									<label for="">Phone</label>
									<input class="form-control" type="text" v-model="county.phone" />
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label for="">Email</label>
									<input class="form-control" type="email" v-model="county.email" />
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label for="">Website</label>
									<input class="form-control" type="text" v-model="county.website" />
								</div>
							</div>
							<div class="col-6">
								<div class="form-group">
									<label for="">Competitor</label>
									<input class="form-control" type="text" v-model="county.competitor" />
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<button
									v-if="authUser.permissions.includes('CONTACT_UPDATE')"
									@click="updateCounty()"
									class="btn btn-primary float-end"
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body">
						<h5 v-if="county.contacts && county.contacts.length > 0">
							👤 Contacts
							<a
								data-bs-toggle="modal"
								data-bs-target="#addContact"
								class="btn btn-outline-primary btn-sm"
								>Add <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
							/></a>
							<button
								@click="showContacts = !showContacts"
								class="btn btn-secondary btn-sm ms-2 float-end"
							>
								<template v-if="!showContacts">Show</template>
								<template v-if="showContacts">Hide</template> contacts
							</button>
						</h5>
						<h5 v-if="county.contacts && county.contacts.length === 0">
							👤 Contacts
							<a
								data-bs-toggle="modal"
								data-bs-target="#addContact"
								class="btn btn-outline-primary btn-sm"
								>Add <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1"
							/></a>
							<span class="fs-6 float-end">There is no contacts</span>
						</h5>
						<small v-if="showContacts" class="mb-3">
							ℹ️ All county contacts
						</small>

						<table v-if="showContacts" :class="'table table-hover mt-2'">
							<thead>
								<tr>
									<th>First name</th>
									<th>Last name</th>
									<th>Email</th>
									<th>Phone</th>
									<th>Title</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="contact in county.contacts">
									<tr role="button" :key="'edit-' + contact.id" @click="editContact(contact)">
										<td class="align-middle">
											{{ contact.first_name }}
										</td>
										<td class="align-middle">
											{{ contact.last_name }}
										</td>
										<td class="align-middle">
											{{ contact.email }}
										</td>
										<td class="align-middle">
											{{ contact.phone }}
										</td>
										<td class="align-middle">
											{{ contact.title }}
										</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="d-flex justify-content-center">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>

		<!-- Modal for adding Contact -->
		<div class="modal fade" id="addContact" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">New contact</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="">First Name</label>
							<input
								type="text"
								class="form-control"
								name="first_name"
								v-model="newContact.first_name"
								required
							/>
						</div>
						<div class="form-group">
							<label for="">Last Name</label>
							<input type="text" class="form-control" v-model="newContact.last_name" required />
						</div>
						<div class="form-group">
							<label for="">Address</label>
							<input type="text" class="form-control" v-model="newContact.address" />
						</div>
						<div class="form-group">
							<label for="">Email</label>
							<input type="email" class="form-control" v-model="newContact.email" required />
						</div>
						<div class="form-group">
							<label for="">Phone</label>
							<input type="text" class="form-control" v-model="newContact.phone" />
						</div>
						<div class="form-group">
							<label for="">Title</label>
							<input type="text" class="form-control" v-model="newContact.title" required />
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
						<button type="submit" @click="storeContact()" class="btn btn-primary">Create</button>
					</div>
				</div>
			</div>
		</div>

		<Activities :key="activityKey" :subjectType="'App\\Models\\County'" :subjectId="$route.params.id" />
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'
import { Modal } from 'bootstrap'
export default {
	name: 'CountyEdit',
	components: { PageHeader, Activities },
	data() {
		return {
			loading: false,
			county: {
				name: '',
			},
			showContacts: true,
			activityKey: 0,
			$addContactModal: null,
			newContact: {
				first_name: '',
				last_name: '',
				address: '',
				email: '',
				phone: '',
				title: '',
				county_id: '',
			},
		}
	},
	mounted() {
		this.$addContactModal = new Modal('#addContact')
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.getCounty()
	},
	methods: {
		getCounty() {
			this.loading = true
			restApi
				.get(`/counties/${this.$route.params.id}`)
				.then(({ data }) => {
					this.loading = false
					this.county = data
					this.newContact.county_id = data.id
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
				})
		},

		updateCounty() {
			restApi
				.put(`/counties/${this.county.id}`, this.county)
				.then(() => {
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'County successfully updated!',
						timer: 2000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		deleteCounty() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: `You won't be able to revert this! `,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/counties/` + this.county.id)
							.then(() => {
								this.$router.push(`/counties`)
								this.$swal.fire({
									icon: 'success',
									title: `County ${this.county.name} successfully deleted!`,
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		// Store new county contact
		storeContact() {
			restApi
				.post(`/county-contacts`, this.newContact)
				.then(({ data }) => {
					this.county.contacts.push(data)
					this.$swal.fire({
						icon: 'success',
						title: 'County contact successfully created!',
						timer: 3000,
					})
					this.$addContactModal.hide()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		editContact(contact) {
			this.$router.push('/county-contacts/edit/' + contact.id)
		},
	},

	watch: {
		$route(to, from) {
			if (to !== from) {
				location.reload()
			}
		},
	},
}
</script>
